import { useTranslation } from "react-i18next";
type PropsType = {
    i18nKey: string | undefined | null,
    transform?: 'uppercase' | 'lowercase'
}

const Translate = (props: PropsType) => {
    const [t] = useTranslation();
    let i18nKey = props.i18nKey === undefined || props.i18nKey === null ? undefined : props.i18nKey + '';
    if(i18nKey && i18nKey.indexOf('.') > -1 && i18nKey.indexOf(' ') === -1) i18nKey = t(i18nKey);
    if(i18nKey && props.transform === 'uppercase') i18nKey = i18nKey.toUpperCase();
    if(i18nKey && props.transform === 'lowercase') i18nKey = i18nKey.toLowerCase();
    return <>{i18nKey}</>;
};

export default Translate;
